import { render, staticRenderFns } from "./MaterialsQuotesPage.vue?vue&type=template&id=9e02ec70&scoped=true&"
import script from "./MaterialsQuotesPage.vue?vue&type=script&lang=js&"
export * from "./MaterialsQuotesPage.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsQuotesPage.vue?vue&type=style&index=0&id=9e02ec70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e02ec70",
  null
  
)

export default component.exports